<mat-card class="example-card">
  <div class="header-row">
    <h2 class="mat-h2">Nutzer-Suche</h2>
    <div class="right">
      <button  (click)="addUser()" mat-raised-button>Nutzer anlegen<mat-icon mat-list-icon>person_add</mat-icon></button>
    </div>
  </div>

  <mat-card-content>
    <div class="example-container">
      <form [formGroup]="filterForm">
        <mat-form-field appearance="outline">
          <mat-label>Eingabe</mat-label>
          <input (keyup)="liveSearch()"
                 (focusout)="closeSuggestions()"
                 matInput
                 formControlName="input">
          <ng-container *ngIf="suggestions">
            <ul class="search-suggestions">
              <li *ngFor="let s of suggestions" (click)="open(s)">{{s.name}} | {{s.email}}</li>
            </ul>
          </ng-container>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Spalte</mat-label>
          <mat-select [(value)]="filterForm.value['column']" formControlName="column">
            <mat-option *ngFor="let col of columns" value="{{col.value}}">{{col.title}}</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="button-field">
          <button (click)="submit()" mat-raised-button color="accent">Suchen <mat-icon mat-list-icon>search</mat-icon></button>
        </div>
        <div class="button-field">
          <button class="reset" (click)="reset()" mat-raised-button>Zurücksetzen <mat-icon mat-list-icon>clear</mat-icon></button>
        </div>

      </form>
    </div>

  </mat-card-content>
  <mat-card-actions>

  </mat-card-actions>
</mat-card>

<mat-card *ngIf="users">
  <h3 mat-subheader>Nutzer</h3>

  <!--  Table-->
  <ng-container *ngIf="usersDataSource">
    <table mat-table [dataSource]="usersDataSource" matSort (matSortChange)="sortResults($event)" class="user-table">

      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let user">
          <mat-icon mat-list-icon>face</mat-icon>
        </td>
      </ng-container>
      <!-- Position Column -->
      <ng-container matColumnDef="given_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Vorname</th>
        <td mat-cell *matCellDef="let user"> {{user.given_name}} </td>
      </ng-container>

      <ng-container matColumnDef="family_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nachname</th>
        <td mat-cell *matCellDef="let user"> {{user.family_name}} </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Email</th>
        <td mat-cell *matCellDef="let user"> {{user.email}} </td>
      </ng-container>

      <ng-container matColumnDef="email_verified">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Email verifiziert</th>
        <td mat-cell *matCellDef="let user"> {{user.email_verified  ? 'Ja' : 'Nein'}} </td>
      </ng-container>

      <ng-container matColumnDef="entry">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Registrierungsdatum</th>
        <td mat-cell *matCellDef="let user"> {{user.entry | date:'short'}} </td>
      </ng-container>

      <ng-container matColumnDef="valid">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Gültig</th>
        <td mat-cell *matCellDef="let user"> {{user.valid ? 'Ja' : 'Nein'}} </td>
      </ng-container>

      <ng-container matColumnDef="edit" class="edit-user">
        <th mat-header-cell *matHeaderCellDef> Bearbeiten</th>
        <td mat-cell (click)="open(user)" *matCellDef="let user">
          <mat-icon mat-list-icon>edit</mat-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </ng-container>


  <!--  end Table-->

  <mat-paginator *ngIf="pager.length && pager.length > 5"
                 [length]="pager.length"
                 [pageSize]="pager.pageSize"
                 [pageIndex]="pager.pageIndex"
                 [pageSizeOptions]="pageSizeOptions"
                 (page)="switchPage($event)">
  </mat-paginator>
</mat-card>

